<script lang="ts">
    import {InsuredDetails} from "../../models/InsuredDetails";
    import {Address} from "../../models/Address";
    import {Suffixes,    getAllUSStates    } from "../../services/ApplicationDataService";
    import {USState} from "../../models/USState";
    import {validateField, validateEmail, validatePhone, alphaNumericPattern} from "../../services/Utilities";
    import AddressUI from "../controls/Address.svelte";
    import MaskInput from "svelte-input-mask/MaskInput.svelte";
    export let insuredDetails: InsuredDetails;
    export let insuredAddress: Address;
    let suffixes: string[]
    let usStates: USState[];
    suffixes = Suffixes();
    usStates = getAllUSStates();

    const stringPattern = alphaNumericPattern();

    const handleChange = ({ detail }) => {

        if (detail.inputState.maskedValue.indexOf('34') === 0 || detail.inputState.maskedValue.indexOf('37') === 0) {
          return;
        }
        insuredDetails.phoneNumber = detail.inputState.maskedValue;
      };
</script>

<div class="text-section">
    <div class="control-row">
        <div class="control-group-horizontal">
            <label>First Name:</label>
            <input bind:value={insuredDetails.firstName} required pattern={stringPattern}    />
        {#if  !validateField( insuredDetails.firstName, stringPattern) }
            <span class="invalidlabel">Valid first name is required</span>
        {/if}
        </div>
    </div>
    <div class="control-row">
        <div class="control-group-horizontal">
            <label>Middle Name:</label>
            <input bind:value={insuredDetails.middleName} maxlength="1" />
        </div>
    </div>
    <div class="control-row">
        <div class="control-group-horizontal">
            <label>Last Name:</label>
            <input bind:value={insuredDetails.lastName} required  pattern={stringPattern}  />
            {#if !validateField( insuredDetails.lastName, stringPattern)}
               <span class="invalidlabel">Last name is required</span>
                    {/if}
        </div>

    </div>

    <div class="control-row">
        <div class="control-group-horizontal">
            <label>Suffix:</label>
            <select bind:value={insuredDetails.suffixName} >
                <option value=''> Select Suffix </option>
            {#each suffixes as suffix}
                <option value={suffix}> {suffix}
                </option>
            {/each}
            </select>

        </div>
    </div>

    <div class="control-row">
        <div class="control-group-horizontal">
            <label>DL Number:</label>
            <input bind:value={insuredDetails.driverLicenseNumber} required/>
             {#if insuredDetails.driverLicenseNumber == ""}
                  <span class="invalidlabel">Driver license is required</span>
             {/if}
        </div>
    </div>

    <div class="control-row">
        <div class="control-group-horizontal">
            <label>DL State:</label>
            <select bind:value={insuredDetails.driverLicenseState} required >
                <option value=''> Select State </option>
                {#each usStates as state}
                    <option value={state.abbreviation}> {state.name}
                    </option>
                {/each}
            </select>

             {#if insuredDetails.driverLicenseState == ""}
                           <span class="invalidlabel">Driver license state is required</span>
                                {/if}
        </div>
    </div>

    <div class="control-row">
        <div class="control-group-horizontal">
            <label>Phone Number (1):</label>
            <MaskInput
              alwaysShowMask
              mask="000-0000000"
              size={11}
              showMask
              maskChar="_"
              required
              bind:value={insuredDetails.phoneNumber}
              on:change={handleChange}

              style="font-weight: normal;
  font-size: 16px;
  min-width: 270px;
  max-width: 560px;
  height: 40px !important;
  color: #4c4c4c;
  border-radius: 2px;
  border: 1px solid #4c12a1;"
            />
             {#if !validatePhone(insuredDetails.phoneNumber)}
               <span class="invalidlabel">Valid phone number is required</span>
             {/if}
        </div>
    </div>

    <div class="control-row">
        <div class="control-group-horizontal">
            <label>Email Address:</label>
            <input bind:value={insuredDetails.emailAddress} required
           type="email" />
           {#if !validateEmail(insuredDetails.emailAddress)}
           <span class="invalidlabel">Valid email address is required</span>
           {/if}
        </div>

    </div>

    <AddressUI bind:address={insuredAddress} showLengthOfResidence= "true"/>

</div>


<style lang="scss">
  @use "../../../component_scss_library/layout" as layout;
  @use "../../../component_scss_library/forms" as forms;
</style>
